import { createServerFn } from "@tanstack/react-start";
import {
  fetchAttributeSiblings,
  fetchCrossMakeAttributeSiblings,
} from "@/lib/attribute-siblings.server";

export const getAttributeSiblings = createServerFn({ method: "GET" })
  .inputValidator((data: { makeSlug: string; dataType: string }) => data)
  .handler(async ({ data }) => {
    const siblings = await fetchAttributeSiblings(data.makeSlug, data.dataType);
    // Brands with only a model or two carrying this attribute would otherwise
    // leave their leaf pages with a single inbound link, so pull in the same
    // attribute from other brands.
    // Cross-brand groups are pulled whenever a brand can't fill its own sibling
    // rail; the caller rotates which model of each brand actually gets linked.
    // This is a nice-to-have link rail, never worth a 502: on a cache miss the
    // bulk scan can outlive the render budget, so time it out and degrade to an
    // empty rail. The underlying load keeps filling the shared cache, so the
    // next request for the same attribute gets the full list.
    let crossMake: Awaited<ReturnType<typeof fetchCrossMakeAttributeSiblings>> = [];
    if (siblings.length < 12) {
      try {
        const groups = await Promise.race([
          fetchCrossMakeAttributeSiblings(data.dataType),
          new Promise<null>((resolve) => setTimeout(() => resolve(null), 3500)),
        ]);
        if (groups) crossMake = groups.filter((s) => s.makeSlug !== data.makeSlug);
      } catch (err) {
        console.error("cross-make siblings failed, degrading:", err);
      }
    }
    return { siblings, crossMake };
  });
